export default __webpack_public_path__ + "locales/ro/DataReassignmentDialog.json?hash=352f5638c9ad8e7cab05639518c159be";